import script from "./IssueSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueSidebar.vue?vue&type=script&setup=true&lang=js"

import "./IssueSidebar.vue?vue&type=style&index=0&id=dddc8cd6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dddc8cd6"]])

export default __exports__